import React, { useEffect, useState, forwardRef } from "react";
import SubNav from "../";
import { scrollToElementByClassName, getSelectedLinkParam } from "../utilities";
import IBuildrProps from '../../../utilities/IBuildrProps';

export interface IParamNavProps extends IBuildrProps {
    url: string;
    defaultLink: string;
    param: string;
    children;
}

const ParamNav = forwardRef((props: IParamNavProps, ref: any) => {
    const { url, children, defaultLink, param = "category" } = props;
    const [selectedLink, setSelectedLink] = useState(null);

    useEffect(() => {
        const category =  getSelectedLinkParam(children, param);
        if (category) {
            setSelectedLink(category);
        }else{
            setSelectedLink((defaultLink || "").toLowerCase())
        }
    }, [children, defaultLink]);

    useEffect(() => {
        scrollToElementByClassName("selected");
    }, [selectedLink]);

    return (
        <div ref={ref} data-id={props.cmsId} className={props.editorClassObj}>
            <SubNav url={url}>
                {
                    React.Children.map(children, (child) => {
                        const category = child.props.url.toLowerCase();

                        return React.cloneElement(child, {
                            ...child.props,
                            selected: category === selectedLink,
                            url: `${url || ''}?${param}=${category}`
                        });
                    })
                }
            </SubNav>
        </div>
    );
});

export default ParamNav;